const Configuration = typeof window === 'undefined' ? {} : window.PRELOAD.CONFIG;

module.exports = Configuration;
